import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function MicrosoftAuthPage() {
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleMicrosoftAuth = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code'); // Get the authorization code from the URL

      if (code) {
        try {
          // Exchange the code for an access token
          const response = await axios.post('https://iassistph.innodata.com/api/microsoft/token', {
            code,
          });

          if (response.data.token) {
            const token = response.data.token;
            console.log('Access Token:', token);

            // You can now use the token to get user information or for other authenticated API calls.
            sessionStorage.setItem('ms_token', token); // Store the token for future use

            // Example: Redirect to the dashboard after successful login
            navigate('/dashboard'); // Or whatever page you want to redirect to after login
          } else {
            setErrorMessage('Failed to get access token.');
          }
        } catch (error) {
          console.error('Error during token exchange', error);
          setErrorMessage('An error occurred during authentication.');
        }
      } else {
        setErrorMessage('Authorization code not found.');
      }
    };

    handleMicrosoftAuth();
  }, [navigate]);

  return (
    <div>
      <h1>Microsoft Authentication</h1>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
    </div>
  );
}

export default MicrosoftAuthPage;
